import React, { useEffect, useRef, useState } from "react";
import styled from "styled-components";
import api from "../../../Component/axios_Interceptor/api";
import api2 from "../../../Component/axios_Interceptor/api2";
import url, { SERVER_ADDRESS } from "../../../Component/server";
import { fontStyles } from "../../../Component/style/common_font";
import {
  CenterView,
  Icon,
  RowView,
  RowView2,
} from "../../../Component/style/common_style";
import Layout_Admin from "../../../Component/UI/Layout_Admin";
import { StoreInfo } from "../../../Component/Interface/Store";

const Setting = () => {
  const [storInfo, setStoreInfo] = useState<StoreInfo>();
  const [storeImage, setStoreImage] = useState<string | null>(null);
  const [picPreview, setPicPreview] = useState("");
  const [emailUrl, setEmailUrl] = useState("");
  const [accNum, setAccNum] = useState("");
  const [bankName, setBankName] = useState("");
  const [accHolder, setAccHolder] = useState("");

  const setting_emailUrl = (e: React.ChangeEvent<HTMLInputElement>) =>
    setEmailUrl(e.target.value);
  const setting_accNum = (e: React.ChangeEvent<HTMLInputElement>) =>
    setAccNum(e.target.value);
  const setting_bankName = (e: React.ChangeEvent<HTMLInputElement>) =>
    setBankName(e.target.value);
  const setting_accHolder = (e: React.ChangeEvent<HTMLInputElement>) =>
    setAccHolder(e.target.value);
  const get_info = async () => {
    try {
      const res = await api.get(url.Communication_url.store_info);
      setStoreInfo(res.data);
      setEmailUrl(res.data.store_email);
      setAccNum(res.data.bank_num);
      setBankName(res.data.bank_name);
      setAccHolder(res.data.depositor);
      setStoreImage(res.data.profile_img);
      setPicPreview(res.data.profile_img);
    } catch (error) {
      console.error("데이터 로드 실패:", error);
    }
  };
  useEffect(() => {
    get_info();
  }, []);

  const picPreviewRef = useRef<HTMLInputElement | null>(null);
  const insert_pic = () => {
    if (picPreviewRef && picPreviewRef.current) {
      picPreviewRef.current.click();
    }
  };
  const delet_pic = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    setPicPreview("");
    setStoreImage("");
  };
  const allowedExtensions = [".png", ".jpg", ".jpeg"];
  const renderPic = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];

    if (file) {
      const fileExtension = file.name.toLowerCase();
      if (!allowedExtensions.some((ext) => fileExtension.endsWith(ext))) {
        alert("png, jpg, jpge 파일만 첨부가능합니다.");
        return;
      }
      const reader = new FileReader();
      reader.onload = (e) => {
        if (e.target && typeof e.target.result === "string") {
          setting_pic(file);
        }
      };
      reader.readAsDataURL(file);
    }
  };
  const setting_pic = async (file: File) => {
    try {
      const res = await api.post(
        url.Communication_url.upload_store_profile,
        { file: file },
        {
          headers: { "Content-Type": "multipart/form-data" },
        }
      );
      if (res.data.message.includes("성공")) {
        setStoreImage(res.data.file_path);
        setPicPreview(res.data.file_path);
      }
    } catch (error) {
      console.error("실패:", error);
    }
  };

  const saveEmail = () => {
    update_info({
      store_email: emailUrl,
      store_seq: storInfo?.seq,
    });
  };

  const saveBank = () => {
    update_info({
      bank_num: accNum,
      bank_name: bankName,
      depositor: accHolder,
      store_seq: storInfo?.seq,
    });
  };

  const saveImage = () => {
    update_info({
      profile_img: storeImage,
      store_seq: storInfo?.seq,
    });
  };

  const update_info = async (send_data: any) => {
    try {
      const res = await api.patch(
        url.Communication_url.store_update,
        send_data
      );
      if (res.data === "성공") {
        alert("수정 되었습니다.");
      }
    } catch (error) {
      console.error("실패:", error);
    }
  };

  return (
    <Layout_Admin menuname={"설정"}>
      <TitleArea>정산서 내용 수정</TitleArea>
      <SubTitle>이메일</SubTitle>
      <InputBox value={emailUrl} onChange={setting_emailUrl} />
      <BtnArea className="end">
        <div onClick={saveEmail}>저장</div>
      </BtnArea>

      <SubTitle>계좌번호</SubTitle>
      <InputBox value={accNum} onChange={setting_accNum} />
      <RowView2 style={{ gap: 16, maxWidth: "30rem" }}>
        <div style={{ flex: 1 }}>
          <SubTitle>은행명</SubTitle>
          <InputBox value={bankName} onChange={setting_bankName} />
        </div>
        <div style={{ flex: 1 }}>
          <SubTitle>예금주명</SubTitle>
          <InputBox value={accHolder} onChange={setting_accHolder} />
        </div>
      </RowView2>
      <BtnArea className="end">
        <div onClick={saveBank}>저장</div>
      </BtnArea>

      <Hr />
      <TitleArea>스토어 프로필 사진</TitleArea>

      <SubTitle>
        사진 등록 <GrayText>500x400(px)</GrayText>
      </SubTitle>
      <PicBox onClick={insert_pic}>
        {picPreview ? (
          <>
            <DelBtn onClick={delet_pic}>
              <Icon src={require("../../../Image/ic_x_circle_white.png")} />
            </DelBtn>
            <Icon src={SERVER_ADDRESS + "openfile/" + picPreview} />
          </>
        ) : (
          <div>+</div>
        )}
      </PicBox>

      <BtnArea className="end">
        <div onClick={saveImage}>저장</div>
      </BtnArea>

      <input
        style={{ display: "none" }}
        ref={picPreviewRef}
        type="file"
        onChange={renderPic}
      />
    </Layout_Admin>
  );
};

export default Setting;

const TitleArea = styled.div`
  margin-bottom: 1rem;
  ${fontStyles.Bold}
  font-size: 20px;
`;
const InputBox = styled.input`
  box-sizing: border-box;
  width: 100%;
  max-width: 30rem;
  padding: 0.8rem 1rem;
  margin: 1rem 0rem;
  ${fontStyles.regular}
  font-size: 16px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  outline: 0;
  &:hover,
  &:focus {
    border: 1px solid #454545;
  }
`;
const GrayText = styled.span`
  margin-left: 5px;
  font-size: 14px;
  color: #8e8e8e;
`;
const PicBox = styled(CenterView)`
  position: relative;
  width: 8rem;
  height: 8rem;
  margin: 1rem 0rem;
  color: #c6c6c6;
  font-size: 24px;
  border: 1px solid #f0f0f0;
  border-radius: 8px;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
    border-radius: 8px;
    object-fit: cover;
  }
`;
const DelBtn = styled.div`
  position: absolute;
  top: -10%;
  right: -10%;
  cursor: pointer;
`;
const BtnArea = styled(RowView2)`
  max-width: 30rem;
  margin-bottom: 30px;
  div {
    padding: 0.4rem 1.5rem;
    ${fontStyles.semiBold}
    color: white;
    background-color: #2d2d2d;
    border-radius: 8px;
    cursor: pointer;
  }
`;
const Hr = styled.div`
  width: 100%;
  height: 1px;
  margin: 2rem 0rem;
  background-color: #f0f0f0;
`;

const SubTitle = styled.div`
  margin-top: 15px;
`;
